import { Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import { dayjs, isNotNullOrUndefined } from '@weft/utils';
import { DefaultThemeDialog } from 'apps/app/src/components/design/DefaultThemeDialog';
import { useDialog } from 'apps/app/src/hooks/use-dialog';
import { runMutation } from 'apps/app/src/utils/vy-mutation';
import React, { useState } from 'react';
import { useRenewContract } from '../../../../../hooks/requests/use-renew-contract';
import { useVyNavigate } from '../../../../../hooks/use-vy-navigate';
import { ContractDatePicker } from '../../../../plans/PlansPage/plans-page-components/ContractDatePicker';

type MenuItemContractRenewalProps = {
  contractId: string;
  contractEndDate: Date;
};

export const MenuItemContractRenewal: React.FC<MenuItemContractRenewalProps> = ({ contractId, contractEndDate }) => {
  const navigate = useVyNavigate();
  const { handleClose, handleOpen, isDialogOpen } = useDialog();
  const renewContractMutation = useRenewContract(contractId);
  
  const defaultContractStartDate = dayjs(contractEndDate).add(1, 'day').toDate();
  const [contractStartDate, setContractStartDate] = useState<Date>(defaultContractStartDate);

  const handleDialogSubmit = async () => {
    await runMutation(
      renewContractMutation,
      { startDate: contractStartDate },
      {
        pending: 'Saving...',
        success: 'Saved',
        error: 'Failed to renew contract',
      },
      {
        onSuccess: ({ contractId: createdContractId }: { contractId: string }) => {
          navigate(`/plans/contracts/${createdContractId}`);
        },
      },
    );
  };

  return (
    <>
      <div>
        <MenuItem
          onClick={handleOpen}
        >
          <Typography>Renew Contract</Typography>
        </MenuItem>

        <DefaultThemeDialog
          open={isDialogOpen}
          onClose={handleClose}
          fullWidth
          PaperProps={{
            className: 'max-w-[780px] px-6 pt-6 overflow-visible',
          }}
        >
          <DialogTitle>You're about to renew the contract</DialogTitle>
          <DialogContent className='mb-4'>
            <DialogContentText>Choose a start date</DialogContentText>
            <div className="mt-5 flex flex-col">
              <ContractDatePicker
                date={contractStartDate}
                onSelect={(newDate) => {
                  if (isNotNullOrUndefined(newDate)) {
                    setContractStartDate(newDate);
                  }
                }}
                fullWidth
                containerClassName="w-full"
              />
            </div>
          </DialogContent>

          <DialogActions>
            <Button
              variant="text"
              color="secondary"
              onClick={handleClose}
              disabled={renewContractMutation.isLoading}
            >
              Cancel
            </Button>

            <button
              type="button"
              onClick={handleDialogSubmit}
              disabled={renewContractMutation.isLoading}
              className="inline-flex justify-center rounded-md border border-transparent
                bg-blue-100 px-4 py-2 text-base font-medium text-blue-900 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 enabled:hover:bg-blue-200 disabled:opacity-50"
            >
              Confirm
            </button>
          </DialogActions>
        </DefaultThemeDialog>
      </div>
    </>
  );
};